/* tslint:disable:triple-equals */
import { createSelector } from "@ngrx/store";
import { getBaseState } from "../store";

const getInvestorsState = createSelector(getBaseState, state => state.investors);

export const getInvestorsLoading = createSelector(getInvestorsState, state => state.loading);

export const getInvestorsList = createSelector(getInvestorsState, state => state.list);

export const getInvestorsListItems = createSelector(getInvestorsList, list => list.items);

export const getInvestorsTotal = createSelector(getInvestorsState, state => state.total ?? 0);

export const getInvestorsTotalPages = createSelector(getInvestorsState, state => state.totalPages ?? 0);

export const getInvestorsCompanyStatsList = createSelector(getInvestorsState, state => state.companiesStats);

export const getInvestorsCompany = (id: number) =>
  createSelector(getInvestorsState, state => state.companiesList.find(c => c.id == id));

export const getInvestorsUser = (id: number) =>
  createSelector(getInvestorsState, state => state.usersList.find(c => c.id == id));

export const getInvestorCompanyStats = (id: number) =>
  createSelector(getInvestorsCompanyStatsList, list => list.find(i => i.companyId == id));
